import { render, staticRenderFns } from "./autoresult.vue?vue&type=template&id=6480b0db&scoped=true"
import script from "./autoresult.vue?vue&type=script&lang=js"
export * from "./autoresult.vue?vue&type=script&lang=js"
import style0 from "./autoresult.vue?vue&type=style&index=0&id=6480b0db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6480b0db",
  null
  
)

export default component.exports